import { Component, OnInit, EventEmitter, Output, Input } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";

@Component({
  selector: "app-scholership-report-search",
  templateUrl: "./scholership-report-search.component.html",
  styleUrls: ["./scholership-report-search.component.css"]
})
export class ScholershipReportSearchComponent implements OnInit {
  @Input() title: string;
  @Output() close: EventEmitter<void> = new EventEmitter();
  @Output() filterChange: EventEmitter<any> = new EventEmitter();
  form: FormGroup;
  groups = [];
  by = [];
  types = [];

  constructor(private fb: FormBuilder) {
    this.buildForm();
  }

  ngOnInit() {}

  buildForm() {
    this.form = this.fb.group({
      name: null,
      gender: null,
      group: null,
      date: null,
      fee_name: null,
      by: null,
      type: null,
      amount: null
    });
  }

  onSearch() {
    this.filterChange.emit(this.form.value);
    this.closeSideOverlay();
  }

  closeSideOverlay(event: Event = null) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.close.emit();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/clubprogram-reports/components/scholership-report-search/scholership-report-search.component.ts